import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Ressult() {
  return (
    <section className="intro_section p-100">
      <Container>
        <Row>
          <Col xs={12} md={12} lg={5} xl={5} xxl={5} className="my-auto">
            <h2>
              The <span style={{ color: "#49A950" }}>Results</span>
            </h2>
            <p>
              The end product that we created was an app with a high concurrency
              rate and unmatched user experience, that will have an overwhelming
              impact on how people get recreational and medical marijuana.
            </p>
          </Col>
          <Col
            xs={12}
            md={12}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto offset-lg-1"
          >
            <StaticImage
              src="../../../images/case-studies/kush-me/tek_img_04.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={804}
              height={861}
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Ressult;
